const dataProductLit = [
    {
        _id:"608b36ff55fb720b783d8d1011",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:56,
        preceCurrent:50,
        costoEnvio:0,
        piezasDiponibles:40,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://1.bp.blogspot.com/-5ETJCHwnQSI/Xq56kQJzp7I/AAAAAAAAiMg/ViyAq04RrF8XtY7Z6sSbSejPRYO79z99ACK4BGAsYHg/w480-h640/olena-sergienko-perfume-channel.jpg',
        fotoProducto2:'https://1.bp.blogspot.com/-5ETJCHwnQSI/Xq56kQJzp7I/AAAAAAAAiMg/ViyAq04RrF8XtY7Z6sSbSejPRYO79z99ACK4BGAsYHg/w480-h640/olena-sergienko-perfume-channel.jpg',
        fotoProducto3:'https://1.bp.blogspot.com/-5ETJCHwnQSI/Xq56kQJzp7I/AAAAAAAAiMg/ViyAq04RrF8XtY7Z6sSbSejPRYO79z99ACK4BGAsYHg/w480-h640/olena-sergienko-perfume-channel.jpg',
        fotoProducto4:'https://1.bp.blogspot.com/-5ETJCHwnQSI/Xq56kQJzp7I/AAAAAAAAiMg/ViyAq04RrF8XtY7Z6sSbSejPRYO79z99ACK4BGAsYHg/w480-h640/olena-sergienko-perfume-channel.jpg'
    },
    {
        _id:"608b36ff55fb720b783d8d1012",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://www.molinaripixel.com.ar/wp-content/uploads/2012/11/foto_cursos_fotografia_productos.jpg',
        fotoProducto2:'https://www.molinaripixel.com.ar/wp-content/uploads/2012/11/foto_cursos_fotografia_productos.jpg',
        fotoProducto3:'https://www.molinaripixel.com.ar/wp-content/uploads/2012/11/foto_cursos_fotografia_productos.jpg',
        fotoProducto4:'https://www.molinaripixel.com.ar/wp-content/uploads/2012/11/foto_cursos_fotografia_productos.jpg'
    }, 
    {
        _id:"608b36ff55fb720b783d8d1013",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d1014",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/RS4AAOSwxr1fgKcW/s-l300.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/RS4AAOSwxr1fgKcW/s-l300.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/RS4AAOSwxr1fgKcW/s-l300.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/RS4AAOSwxr1fgKcW/s-l300.jpg'
    },  
    {
        _id:"608b36ff55fb720b783d8d1015",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    }, 
    {
        _id:"608b36ff55fb720b783d8d1016",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:500,
        preceCurrent:490,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg'
    },    
    {
        _id:"608b36ff55fb720b783d8d1017",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:189,
        preceCurrent:179,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg'
    },
    {
        _id:"608b36ff55fb720b783d8d1018",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:120,
        preceCurrent:110,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg'
    },    
    {
        _id:"608b36ff55fb720b783d8d1019",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:200,
        preceCurrent:199,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg'
    },    
    {
        _id:"608b36ff55fb720b783d8d1010",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:320,
        preceCurrent:315,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://sc04.alicdn.com/kf/Ha745768a819b4728ae218fe73cc9baa1c.png',
        fotoProducto2:'https://sc04.alicdn.com/kf/Ha745768a819b4728ae218fe73cc9baa1c.png',
        fotoProducto3:'https://sc04.alicdn.com/kf/Ha745768a819b4728ae218fe73cc9baa1c.png',
        fotoProducto4:'https://sc04.alicdn.com/kf/Ha745768a819b4728ae218fe73cc9baa1c.png'
    },    
    {
        _id:"608b36ff55fb720b783d8d100",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:90,
        preceCurrent:89,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://sc04.alicdn.com/kf/He19560e1dee54fd3afcddd0b86ac9d47G.png',
        fotoProducto2:'https://sc04.alicdn.com/kf/He19560e1dee54fd3afcddd0b86ac9d47G.png',
        fotoProducto3:'https://sc04.alicdn.com/kf/He19560e1dee54fd3afcddd0b86ac9d47G.png',
        fotoProducto4:'https://sc04.alicdn.com/kf/He19560e1dee54fd3afcddd0b86ac9d47G.png'
    },    
    {
        _id:"608b36ff55fb720b783d8d101",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:2900,
        preceCurrent:2899,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://sc04.alicdn.com/kf/H751d06a21c434cdb97892a61d5199aa6r.png',
        fotoProducto2:'https://sc04.alicdn.com/kf/H751d06a21c434cdb97892a61d5199aa6r.png',
        fotoProducto3:'https://sc04.alicdn.com/kf/H751d06a21c434cdb97892a61d5199aa6r.png',
        fotoProducto4:'https://sc04.alicdn.com/kf/H751d06a21c434cdb97892a61d5199aa6r.png'
    },    {
        _id:"608b36ff55fb720b783d8d102",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d103",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d104",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d105",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d106",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d107",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d108",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },    {
        _id:"608b36ff55fb720b783d8d109",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:360,
        preceCurrent:340,
        costoEnvio:0,
        piezasDiponibles:30,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto2:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto3:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
        fotoProducto4:'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg'
    },
]

export default dataProductLit;


        





// 'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg',
// 'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/3b4AAOSwfY1gbm9X/s-l400.jpg',
// 'https://i.ebayimg.com/images/g/RS4AAOSwxr1fgKcW/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/hZIAAOSwbc1fY-l7/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/UhQAAOSwoqZfRmIx/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/xwkAAOSw64NgBrH9/s-l300.jpg',
// 'https://i.ebayimg.com/images/g/b~0AAOSwOj1gjmlR/s-l400.jpg',
// 'https://i.ebayimg.com/images/g/USUAAOSwfDBgGgph/s-l300.jpg'

